import initialState from '../store/initialState'
import businessesTypes from '../constants/businessesTypes'
import preferencesTypes from '../constants/preferencesTypes'

export default function businessesReducer(state = initialState.businesses, action) {
  switch (action.type) {

    case businessesTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case businessesTypes.reset_business: {
      return {
        ...initialState.businesses,
        items: state.items,
        business: state.business,
        totals: state.totals,
        pagination: state.pagination
      }
    }

    case businessesTypes.clear_business: {
      return {
        ...initialState.businesses,
        business: {
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
      }
    }
    // GET
    case businessesTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case businessesTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        business: action.payload,
        errors: []
      }
    }

    case businessesTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case businessesTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case businessesTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        errors: [],
        business: action.payload
      }
    }

    case businessesTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // INDEX
    case businessesTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case preferencesTypes.update.success:
    case preferencesTypes.index.success: {
      return {
        ...state,
        items: action.payload.businesses,
      }
    }

    case businessesTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.businesses,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case businessesTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.businesses,
        errors: []
      }
    }

    case businessesTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // ACTIVATE, DEACTIVATE
    case businessesTypes.activate.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case businessesTypes.activate.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.businesses,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case businessesTypes.activate.single:{
      const {active} = action.payload.business
      return {
        ...state,
        setting_status: false,
        set_status: true,
        business: {
          ...state.business,
          active: active,
        }
      };
    }

    case businessesTypes.activate.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }

    // CREATE
    case businessesTypes.create.init: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case businessesTypes.create.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case businessesTypes.create.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        business: action.payload,
        errors: []
      }
    }

    case businessesTypes.create.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/businessesReducer.js